























import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { Size } from "../../../../../../../base/domain/drawing";
import {
  ModelEditableMixin,
  DisableableMixin,
} from "../../../../../../../base/components/system/mixins";
import { FormatPageStructureEditableMixin } from "../../../mixins";
import { OptionDropDownSelector, OptionRadioSelector } from "../../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";

@Component({
  components: {
    OptionDropDownSelector,
    OptionRadioSelector,
  },
})
export default class FormatPagePropertyEditor extends Mixins(ModelEditableMixin, DisableableMixin, FormatPageStructureEditableMixin) {
  get sizeOptions(): StandardOption<Size>[] {
    return Enumerable.from(this.papers)
      .select(p => new StandardOption<Size>(p.name, Size.from(p.size)))
      .toArray();
  }

  get editingSize(): Size {
    return this.findPaper(this.size);
  }

  set editingSize(value: Size) {
    this.size = value;
  }

  private findPaper(source: Size): Size {
    // 小数点以下を切り捨てて探す
    const width = Math.floor(source.width);
    const height = Math.floor(source.height);
    return Enumerable.from(this.sizeOptions)
      .select(o => o.value)
      .firstOrDefault(s => width === Math.floor(s.width) && height === Math.floor(s.height));
  }

  get orientationOptions(): StandardOption<boolean>[] {
    return [
      new StandardOption<boolean>("縦", false),
      new StandardOption<boolean>("横", true),
    ];
  }
}
